export default "__VITE_ASSET__BINCKLko__"